<template>
  <b-container>
    <section v-if="errored">
      <b-card bg-variant="danger" text-variant="white" class="text-center my-3">
        <b-card-title>Error</b-card-title>
        <b-card-text
          >We're sorry, we're not able to retrieve this information at the
          moment, please try again later.
        </b-card-text>
      </b-card>
    </section>

    <section v-else>
      <b-card v-if="loading" class="my-3">
        <b-overlay :show="true" no-wrap> </b-overlay>
      </b-card>

      <b-card
        v-else-if="hasData == false"
        bg-variant="danger"
        text-variant="white"
        class="text-center my-3"
      >
        <b-card-title>Error</b-card-title>
        <b-card-text>
          Keine Daten zu diesem Einsatz gefunden.
        </b-card-text>
      </b-card>

      <b-card
        v-else
        v-for="einsaetze in info.einsaetze"
        v-bind:key="einsaetze.num1"
        bg-variant="dark"
        text-variant="white"
        class="my-3"
      >
        <b-card-title>
          {{ einsaetze.einsatz.einsatzort | isNullStr }}
          <b-badge pill variant="danger" v-b-tooltip.hover title="Alarmstufe">
            {{ einsaetze.einsatz.alarmstufe | isNullStr }}
          </b-badge>
        </b-card-title>

        <b-card-sub-title class="mb-2">
          {{ einsaetze.einsatz.einsatztyp.text | isNullStr }}
        </b-card-sub-title>

        <b-card-text>
          <b-icon-clock></b-icon-clock>
          <br />
          <span class="ml-4" v-b-tooltip.hover title="Startzeit">
            {{ einsaetze.einsatz.startzeit | formatDate("datetime") }}
          </span>
          <br />

          <b-icon-info-circle></b-icon-info-circle>
          <br />
          <span class="ml-4" v-b-tooltip.hover title="Einsatzstatus">
            Status: {{ einsaetze.einsatz.status | isNullStr }}
          </span>
          <br />
          <span class="ml-4" v-b-tooltip.hover title="Einsatzart">
            {{ einsaetze.einsatz.einsatzart | isNullStr }}
          </span>
          <br />
          <span class="ml-4" v-b-tooltip.hover title="Einsatztyp">
            {{ einsaetze.einsatz.einsatztyp.text | isNullStr }}
          </span>
          <br />
          <span class="ml-4" v-b-tooltip.hover title="Einsatzsubtyp">
            {{ einsaetze.einsatz.einsatzsubtyp.text | isNullStr }}
          </span>
          <br />

          <b-icon-house></b-icon-house>
          <br />
          <span class="ml-4" v-b-tooltip.hover title="Adresse">
            {{ einsaetze.einsatz.adresse.default | isNullStr }}
          </span>
          <br />
          <span class="ml-4" v-b-tooltip.hover title="Gemeinde">
            {{ einsaetze.einsatz.adresse.emun | isNullStr }}
          </span>
          <br />
          <span class="ml-4" v-b-tooltip.hover title="Adresszusatz">
            {{ einsaetze.einsatz.adresse.ecompl | isNullStr }}
          </span>
          <br />
          <span class="ml-4" v-b-tooltip.hover title="Bezirk">
            {{ einsaetze.einsatz.bezirk.text | isNullStr }}
          </span>
          <br />
          <br />
          <span>
            <b-icon-bucket-fill></b-icon-bucket-fill>
            Aktive Feuerwehren ( {{ einsaetze.einsatz.cntfeuerwehren }} ):
          </span>
          <b-list-group>
            <b-list-group-item
              v-for="feuerwehren in einsaetze.einsatz.feuerwehren"
              v-bind:key="feuerwehren.feuerwehr"
              variant="dark"
            >
              {{ feuerwehren.feuerwehr }}
            </b-list-group-item>
          </b-list-group>
        </b-card-text>

        <b-button-group>
          <b-button
            :to="{
              name: 'Root'
            }"
            variant="warning"
          >
            <b-icon-list></b-icon-list> Zur Übersicht
          </b-button>

          <b-button
            target="_blank"
            :href="
              'https://www.google.com/maps/search/?api=1&query=' +
                einsaetze.einsatz.wgs84.lat +
                ',' +
                einsaetze.einsatz.wgs84.lng
            "
            variant="info"
          >
            <b-icon-map></b-icon-map> Auf der Karte anzeigen
          </b-button>
        </b-button-group>
      </b-card>
    </section>
  </b-container>
</template>

<script>
export default {
  name: "Home",

  data() {
    return {
      // eslint-disable-next-line prettier/prettier
      //API_URL: "https://intranet.ooelfv.at/webext2/detail.php?output=json&NUM1=",
      API_URL: "https://vanora.eu/feuerwehr/api/proxy/einsatz/",
      PROXY_URL: "https://cors-anywhere.herokuapp.com/",
      info: null,
      loading: true,
      errored: false
    };
  },

  mounted() {
    this.fetchData();
  },

  watch: {
    selected: function() {
      this.fetchData();
    }
  },

  filters: {
    formatDate(date, mode) {
      if (date == null || date == "") {
        return "";
      }

      var dt = new Date(date);
      var d = dt.getDate();
      var m = dt.getMonth() + 1;
      var Y = dt.getFullYear();
      var h = dt.getHours();
      var i = dt.getMinutes();

      if (d < 10) {
        d = "0" + d;
      }
      if (m < 10) {
        m = "0" + m;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (i < 10) {
        i = "0" + i;
      }

      if (mode == "datetime") {
        return d + "." + m + "." + Y + ", " + h + ":" + i + " Uhr";
      } else {
        return h + ":" + i + " Uhr";
      }
    },
    capitalizeFirstLetter(str) {
      if (str == null) {
        return "";
      }

      return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    isNullStr(str) {
      if (str == null || str == "" || str == " ") {
        return "-";
      }
      return str;
    }
  },

  methods: {
    fetchData() {
      const einsatzNum = this.$route.params.einsatzNum;
      this.loading = true;
      this.errored = false;
      this.hasData = true;
      this.axios
        //.get(this.PROXY_URL + this.API_URL + einsatzNum + "&callback=callback")
        .get(this.API_URL + einsatzNum)
        .then(response => {
          if (response.data.error !== undefined) {
            this.hasData = false;
          } else {
            this.hasData = true;

            /*var tmp = response.data.replace("callback(", "");
            tmp = tmp.substring(0, tmp.length - 2);
            this.info = JSON.parse(tmp);*/
            this.info = response.data;
          }
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
